import { useEffect, useState } from 'react';
import { getMessageUnreadCount, getPendingIncomingRequestsCount } from '@/lib/api';

export const useNavBadges = (user) => {
  const [badges, setBadges] = useState({ messages: 0, requests: 0 });

  useEffect(() => {
    if (!user) { setBadges({ messages: 0, requests: 0 }); return; }
    const load = () => {
      getMessageUnreadCount().then((r) => setBadges((b) => ({ ...b, messages: r.data.count || 0 }))).catch(() => {});
      getPendingIncomingRequestsCount().then((r) => setBadges((b) => ({ ...b, requests: r.data.count || 0 }))).catch(() => {});
    };
    load();
    const iv = setInterval(load, 15000);
    return () => clearInterval(iv);
  }, [user]);

  return badges;
};
